import React, { useState, useContext, useEffect,useRef } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { TiArrowSortedDown } from "react-icons/ti";
//pages & includes
import ManageSidebar from "../ManageSidebar";
import { ExportToCsv } from 'export-to-csv';
//functions
import {
  _t,
  getCookie,
  modalLoading,
  tableLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
  formatPrice,
  currencySymbolLeft,
  currencySymbolRight,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Switch from "react-switch";
import Moment from "react-moment";

import { SettingsContext } from "../../../../../contexts/Settings";

//context consumer
import { FoodContext } from "../../../../../contexts/Food";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import FoodDeal from "./FoodDeal"
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const FoodItemDeptList = () => {
  const { t } = useTranslation();
  const history = useHistory();

  let { generalSettings } = useContext(SettingsContext);
  //getting context values here
  let {
    //common
    loading,
    setLoading,

    //foodGroup
    foodGroupForSearch,

    //property group
    propertyGroupForSearch,

    //food
    foodList,
    setFoodList,
    setPaginatedFood,
    //propertyItemForSearch,
    foodForSearch,
    setFoodForSearch,
    getFoodItemsForPOS,
    //variations
    variationForSearch,

    //pagination
    dataPaginating,
    setDataPaginating,
  } = useContext(FoodContext);

  let {
    //dept-tag
    // getDeptTag,
    // deptTagList,
    // setDeptTagList,
    // setPaginatedDeptTag,
    deptTagForSearch,
    // setDeptTagForSearch,

    // branchForSearch,
    // orderTypeForSearch,
  } = useContext(RestaurantContext);

  // States hook here
  let [variations, setVariations] = useState({
    //common
    edit: false,
    uploading: false,

    //food item === item
    item: null,

    //variation list === list
    list: null,

    //new price of variations
    newPrice: null,

    //new price of variations
    newStatus: null,

    //new cost of variations
    newCost: null,

    //variation to delete- id of food_with_variations table
    deletedVariations: null,

    //if all variation deleted
    priceAfterAllVariationDelete: "",
  });

  const menuWisePrice = useRef(0);
  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    // headers: ["Id", "Name", "Cost Price", "Price", "Food Group Name", "Menu Name 1", "Price 1", "Menu Name 2", "Price 2", "Menu Name 3", "Price 3", "Menu Name 4", "Price 4", "Menu Name 5", "Price 5", "Sku", "Status"],
    filename: 'Food-item',
  };
  const csvExporter = new ExportToCsv(options);

  let [deptTagForSearchObj, setDeptTagForSearchObj] = useState({});
  //pop up modal
  const [foodSort,setFoodSort] = useState(false);
  const [listItem,setListItem] = useState([]);
  const [sortGroup,setSortGroup]=useState(false);
  const groupName =  useRef("");
  //const componentRef = useRef();

  let [createDeal,setCreateDeal] = useState({
    id: null,
    name:"",
    uploading:false,
    modal: false
  });
  
  // csv item
  // const [generatedReport, setGeneratedReport] = useState(false);
  // const [itemCsv,setItemCsv] = useState([]);
  const [uploadCsv,setUploadCsv] = useState(null);
  const [uploadCsvModal,setUploadCsvModal] = useState(false);
  //search result
  let [searchedFoodItem, setSearchedFoodItem] = useState({
    list: null,
    searched: false,
  });

  //useEffect == componentDidMount
  useEffect(()=>{
    if(getSystemSettings(generalSettings, "menu_wise_rate") == 1){
      menuWisePrice.current = 1
    }
  },[generalSettings])

  useEffect(() => {
    if (
      history.location.state &&
      history.location.state.from &&
      history.location.state.from === 'restrictions'
    ) getFoodItemsForPOS(true)
  }, [history.location])

  useEffect(() => {
    if (deptTagForSearch && deptTagForSearch.length) {
      const obj = {}
      for(const deptTag of deptTagForSearch) {
        obj[deptTag.id] = deptTag
      }
      setDeptTagForSearchObj(obj)
    }
  }, [deptTagForSearch])

  const handleUpdateStatus = (item) =>{
  
    setVariations({ ...variations, uploading: true });
    let formData = {
      //item id
      itemId: item.id,
      item_status: !item.item_status == true ? 1 : 0,

    };
    const url = BASE_URL + `/settings/update-food-item-status`;
    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setFoodList(res.data[0]);
        setFoodForSearch(res.data[1]);
        const search = document.getElementById("item_search").value.toLowerCase();
        if(search){
          const searchedList = res.data[1].filter((item) => {
            let lowerCaseItemName = item.name?.toLowerCase();
            let lowerCaseItemGroup = item?.food_group_name?.toLowerCase();
            let lowerCaseGroup = item.groups && item.groups[0] && item.groups[0][0]?.name?.toLowerCase()
            return (
              (lowerCaseGroup && lowerCaseGroup.includes(search)) ||
              (lowerCaseItemName && lowerCaseItemName.includes(search)) ||
              (lowerCaseItemGroup && lowerCaseItemGroup.includes(search)) 
            );
          });
        
          setSearchedFoodItem({
            ...searchedFoodItem,
            list: searchedList,
            searched: true,
          });
        }
        // getFoodItemsForPOS();
        setVariations({ ...variations, uploading: false });
        toast.success(`${_t(t("Food item has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });

      })
      .catch((error) => {
        setVariations({ ...variations, uploading: false });
        if(error.response.data.status === 0){
          toast.error(`${_t(t(error.response.data.message))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return
        }
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  } 

  const handleStatus = (e) => {
    const id = e.target.name.replace(/(-status)/g, '');
    console.log('ar-log id', id);
    if (variations.list.length === 1) {
      toast.error('To turn off this one variation, you must deselect Has Variation option in item settings.', {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      })
    } else {
      const newNewStatus = {
        ...variations.newStatus,
        [id]: e.target.checked ? 1 : 0,
      }
      const howManyOff1 = variations.list.reduce(
        (acc, item) => {
          if (item.variation_status!=0)
            return acc
          if (item.food_with_variation_id in newNewStatus)
            return acc
          return acc + 1
        }, 0);
      const howManyOff = Object.values(newNewStatus)
        .reduce((acc, item) => (acc + (item==0 ? 1 : 0)), 0);
      if (!e.target.checked && (howManyOff+howManyOff1) === variations.list.length) {
        toast.error('At least one variation must be turned on.', {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        })
      } else {
        setVariations({
          ...variations,
          newStatus: newNewStatus,
        });
      }
    }
  }

  const handleEditDeal = (item) =>{

    setCreateDeal({
      ...createDeal,
      id:item.id,
      name:item.name,
      deal_item: item.deal_item,
      modal: true
    })
  }

  //search food here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedFoodItem({ ...searchedFoodItem, searched: false });
    } else {
      const searchedList = foodForSearch.filter((item) => {
        let lowerCaseItemName = item.name?.toLowerCase();
        let lowerCaseItemGroup = item?.food_group_name?.toLowerCase();
        let lowerCaseGroup = item.groups && item.groups[0] && item.groups[0][0]?.name?.toLowerCase()
        // &&
        // item.groups.map((group_item, i) => (
        //   group_item && group_item[0]?.name?.toLowerCase()
        // ));
        return (
          (lowerCaseGroup && lowerCaseGroup.includes(searchInput)) ||
          (lowerCaseItemName && lowerCaseItemName.includes(searchInput)) ||
          (lowerCaseItemGroup && lowerCaseItemGroup.includes(searchInput)) 
        );
      });
    
      setSearchedFoodItem({
        ...searchedFoodItem,
        list: searchedList,
        searched: true,
      });
    }
  };

  // desc and image add
  const handleItemConfirmation = (text, type) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h2>{_t(t("Are you sure?"))}</h2>
            <p className="text-center">{_t(t(text))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary px-3 rounded"
                onClick={() => {
                  handleItemDescImage(type);
                  onClose();
                }}
              >
                {_t(t("Yes"))}
              </button>
              <button className="btn btn-success ml-2 px-3 rounded" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleItemDescImage = (type) =>{
    setLoading(true);
    const url = BASE_URL + `/settings/food-item-descImage/${type}`;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setLoading(false);
        toast.success(`${_t(t(res.data.message))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  //delete confirmation modal of food item
  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeleteFood(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3 rounded" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete food here
  const handleDeleteFood = (slug) => {
    setLoading(true);
    const url = BASE_URL + `/settings/delete-food-item/${slug}`;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setFoodList(res.data[0]);
        setFoodForSearch(res.data[1]);
        setSearchedFoodItem({
          ...searchedFoodItem,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Item has been deleted successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  const handleFoodCsv = () =>{
    const url = BASE_URL + `/settings/get-food-item-for-csv`;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        // setItemCsv(res.data)
        // setGeneratedReport(true);
        csvExporter.generateCsv(res.data);
        setLoading(false);
        
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  function isCSV(contents) {
    // Basic check if it's a CSV file by checking if it contains a comma
    const rows = contents.split('\n');

    // Extract the header row (assuming it's the first row)
    const headerRow = rows[0];

    // Split the header row into individual header values
    const headers = headerRow.split(',');
    return contents.includes(',') && contents.includes('\n') && (headers.length === 17);
  }

  const handleOnChange = (e) => {
    if (e.target.files[0]) {
      const fileReader = new FileReader();
      fileReader.readAsText(e.target.files[0]);
      fileReader.onload = (e) => {
        const contents = e.target.result;
      
        let missPrice = "";
        if(isCSV(contents)){
          const startIndex = 1; // Start index
          const lines = contents.trim().split('\n').slice(startIndex);
          const parsedData = lines.map((line)=>{
            const values = line.split(',').map(value => value.replace(/["/\r\n]/g, ''));
            if(menuWisePrice.current){
              if(values[6] === null || values[6] === ""){
                missPrice += values[1] + ", "
              }
            }else{
              if(values[3] === null || values[3] === ""){
                missPrice += values[1] + ", "
              }
            }

            return {
              id : values[0],
              item_name : values[1],
              cost_price : values[2],
              price : values[3],
              food_group_name : values[4],
              menu_name_1: values[5],
              menu_price_1: values[6],
              menu_name_2: values[7],
              menu_price_2: values[8],
              menu_name_3: values[9],
              menu_price_3: values[10],
              menu_name_4: values[11],
              menu_price_4: values[12],
              menu_name_5: values[13],
              menu_price_5: values[14],
              sku : values[15],
              status : values[16],
            }
          })
          setUploadCsv(parsedData);
        }else {  
          if (document.getElementById('uploadFile')) {
            document.getElementById('uploadFile').value = '';
          }
          setUploadCsv(null)
          setUploadCsvModal(false)
          toast.error("Please upload only food item csv file", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }); 
          // const startIndex = 2; // Start index
          // const lines = contents.split('<tr>');
          // const portion = lines.slice(startIndex);
          // const parsedData = portion.map((line) => {
          //   // Extract the content from the <td> element
          //   const tdContent = line.match(/<td[^>]*>(.*?)<\/td>/g);
          //   if(tdContent){
          //   const divId = document.createElement('div');
          //   divId.innerHTML = tdContent[0];
          //   const divVarId = document.createElement('div');
          //   divVarId.innerHTML = tdContent[1]; 
          //   const divfoodGrp = document.createElement('div');
          //   divfoodGrp.innerHTML = tdContent[3]; 
          //   const divName = document.createElement('div');
          //   divName.innerHTML = tdContent[2]; 
          //   const divVar = document.createElement('div');
          //   divVar.innerHTML = tdContent[4]; 
          //   const divPrice = document.createElement('div');
          //   divPrice.innerHTML = tdContent[5];
          //   const divCostPrice = document.createElement('div');
          //   divCostPrice.innerHTML = tdContent[6]; 
          //   if(divPrice.textContent === null || divPrice.textContent === ""){
          //     missPrice += divName.textContent + ", ";
          //   } 
          //   fileUpload.push({
          //     id : divId.textContent,
          //     variation_id : divVarId.textContent,
          //     food_group_name : divfoodGrp.textContent,
          //     item_name : divName.textContent,
          //     variation_name : divVar.textContent,
          //     price : divPrice.textContent,
          //     cost_price : divCostPrice.textContent,
          //   })
          // }
          // });
        } 

        if(missPrice !== "" && missPrice !== null){
          toast.error("Please add price in " + missPrice, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      };
    }; 
  }
 
  const handleFoodCsvSubmit = (e) => {
    e.preventDefault();
    
    const url = BASE_URL +"/settings/food-item-for-csv";
    let formData = {
      items : uploadCsv
    }
    if(!uploadCsv || uploadCsv.length === 0){
      toast.error(`${_t(t("Please upload file"))}`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false
    }
    
    setLoading(true);
    return axios
      .post(url,formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (document.getElementById('uploadFile')) {
          document.getElementById('uploadFile').value = '';
        }
        setFoodList(res.data[0]);
        setFoodForSearch(res.data[1]);
        setSearchedFoodItem({
          ...searchedFoodItem,
          list: res.data[1],
        });
        setUploadCsv(null);
        setFoodSort(false);
        setUploadCsvModal(false)
        setLoading(false);
        setListItem([])
        toast.success(`${_t(t("Item file upload successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        
      })
      .catch(() => {
        setLoading(false);
        setUploadCsv(null);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  const handleOnDragEnd = (result) =>{
    if (!result.destination) return;

    const items = listItem;
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setListItem(items);
  }

  //drag style
  const getItemStyle = (isDragging, draggableStyle) => ({
    background: isDragging ? "white" : "",
    backgroundColor: isDragging ? "white" : "",
    // styles we need to apply on draggables
    ...draggableStyle
  });

  // filter item by category
  const handleFoodSortList = (groupItem) =>{
    const url = BASE_URL + `/settings/get-food-item-by-id/${groupItem.id}`;
    groupName.current = groupItem.name;

    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setListItem(res.data[0]);
        setFoodSort(true);
        setSortGroup(false)
        setLoading(false);
        
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  // update food item sort
  const handleUpdateFoodSort = (e) =>{
    e.preventDefault()
    let orderItem = [] 
    listItem && listItem.forEach((item,index)=>{
      orderItem.push({
        ...item,
        sort:index+1
      })
    })
    const url = BASE_URL +"/settings/update-food-item-sort";
    setDataPaginating(true);
    let formData = {
     sortedList:orderItem
    }
    return axios
      .post(url,formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setFoodList(res.data[0]);
        setFoodForSearch(res.data[1]);
        setSearchedFoodItem({
          ...searchedFoodItem,
          list: res.data[1],
        });
        setFoodSort(false);
        setDataPaginating(false);
        setListItem([])
        toast.success(`${_t(t("Item sorting has been updated successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        
      })
      .catch(() => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  const foodDataList = (item, index) =>{
    return (
      <tr
        className="align-middle"
        key={item.id}
      >
        <th
          scope="row"
          className="xsm-text text-capitalize align-middle text-center"
        >
          {index +
            1 +
            (foodList.current_page - 1) *
              foodList.per_page}
        </th>

        <td
          scope="row"
          className="xsm-text text-capitalize align-middle text-center"
        >
          {item?.id}
        </td>

        <td className="xsm-text">
          <img className="table-image mx-auto" src={item.image || "/assets/img/waiter.jpg" } alt=""/>
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {item?.name}
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {item?.menu_ids ?
          JSON.parse(item.menu_ids).map((menuId, i, menus) => (
            <>
              {deptTagForSearchObj[menuId] ? 
              <span>
                {deptTagForSearchObj[menuId].name}
                {i!==menus.length-1 ? ', ': ''}
              </span>
              : ''}
            </>
          ))
          : '-'}
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {/* {item.food_group_name} */}
          {item.food_item_attributes?.category_name ?
            item.food_item_attributes.category_name : "-" 
          }
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {/* {item.food_group_name} */}
          {item.food_item_attributes?.sub_category_name ?
            item.food_item_attributes.sub_category_name : "-" 
          }
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {item.food_item_attributes?.department_name ?
            item.food_item_attributes.department_name : "-" 
          }
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {currencySymbolLeft()}
          {formatPrice(item.price)}
          {currencySymbolRight()}
        </td>

        {/* <td className="xsm-text text-uppercase align-middle text-center font-weight-bold">
          <Switch
            checked={item?.item_status}
            name="status"
            onChange={(e) => {
              handleUpdateStatus(item)
            }}
            height={22}
            width={44}
            offColor="#ee5253"
          />
        </td> */}

        <td className="xsm-text text-capitalize align-middle text-center">
          <NavLink
          to={`/dashboard/manage/food/edit-item/${item.id}`}
          className="btn btn-primary btn-sm ml-2 rounded-sm"
          title="Edit"
          >
            <i className="fa fa-pencil" aria-hidden="true" style={{cursor: "pointer", fontSize: "1rem", color:"white"}}></i>                             
          </NavLink>
        
          <button
          className="btn btn-success btn-sm ml-2 rounded-sm"
          onClick={() => {
            handleEditDeal(item)
          }}
          data-toggle="modal"
          data-target="#createDeal"
          title="Create/Edit Deal"
          >
            <img style={{height:"1.2rem"}} src="/assets/img/fast-food.png" />
          </button>

            
          {(item?.has_property === '1' && item?.property_groups?.length) ?
          <button
            className="btn btn-secondary btn-sm ml-2 rounded-sm"
            onClick={() => {
              history.push(
                '/dashboard/manage/food/addon-restriction',
                {item}
              )
            }}
            title="Addon restriction"
          >
            <img style={{height:"1.2rem"}} src="/assets/img/forbidden.png" />
          </button>
            : null
          }
        </td>
        <td className="xsm-text text-capitalize align-middle text-center">
          {
            item?.sku ? (
              item.sku
            ) : "-"
          }
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {
            item?.created_at ? (
              <Moment format="LL">
                {item.created_at}
              </Moment>
            ) : ""
          }
        </td>

        <td className="xsm-text text-capitalize align-middle text-center">
          {
            item?.updated_at ? (
              <Moment format="LL">
                {item.updated_at}
              </Moment>
            ) : ""
          }
        </td>
      </tr>
    )
  }

  return (
    <>
      <Helmet>
        <title>{_t(t("Food Items"))}</title>
      </Helmet>
  
      {/*upload csv Modal*/}
      <div
        className={`modal fade ${
          uploadCsvModal !== false ? "showing" : ""
        }`}
        id="addReason"
        aria-hidden="true"
      >
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header align-items-center">
            <div className="fk-sm-card__content"></div>
            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={(e) => {
                if (document.getElementById('uploadFile')) {
                  document.getElementById('uploadFile').value = '';
                }
                setUploadCsv(null)
                setUploadCsvModal(false)
              }}
            ></button>
          </div>
          <div className="modal-body">
            {/* show form or show saving loading */}
            <div key="fragment-food-group-1">
              <form onSubmit={handleFoodCsvSubmit} autoComplete="off">
                <div>
                  <label htmlFor="name" className="form-label">
                    {_t(t("Upload File"))}{" "}
                    <small style={{ color: "red" }}>*</small>
                  </label>
                  <br/>
                  <input
                    type={"file"}
                    id="uploadFile"
                    name="uploadFile"
                    accept={".csv"}
                    onChange={handleOnChange}
                  />
                 </div>
                 <button
                 disabled={loading}
                 type="submit"
                 className="btn btn-primary xsm-text text-uppercase px-3 py-2 my-4 rounded"
                 >
                   {_t(t("Submit"))}
                 </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    
     {/* Add variation modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-table-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {/* {variations.uploading === true || loading === true ? (
                      tableLoading()
                    ) : ( */}
                      <div key="fragment3">
                        {/* next page data spin loading */}
                        <CustomSpinLoader loading={loading || dataPaginating}/>
                        {/* spin loading ends */}

                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb d-flex justify-content-between align-items-center">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!searchedFoodItem.searched
                                    ? _t(t("Food Items List"))
                                    : _t(t("Search Result"))}
                                </span>
                                <span title="Item Sort By Groups" >
                                <TiArrowSortedDown  className="dashboard_card_down cursor-pointer ml-3" onClick={()=>setSortGroup(!sortGroup)}/>
                                </span>
                                {
                                  sortGroup === true && (
                                  <div className="dropdownSelect w-25 ml-3 mr-1 p-0">
                                    <h6 className="ml-2 px-2 mt-2">Food Groups</h6>
                                    <div className={`custom_scrollBar ${foodGroupForSearch?.length > 10 && "custom_scrollHeight"}`} >
                                      {foodGroupForSearch?.map((groupItem, groupIndex)=>{
                                      return (
                                        <span className="m-0 p-0" key={groupIndex}  onClick={() => handleFoodSortList(groupItem)}>
                                         <li className="list-unstyled dashboard_border p-1 mb-1 cursor-pointer">{groupItem.name}</li>
                                        </span>
                                      )
                                      })}
                                    </div>
                                  </div>
                                  )
                                }
                              </li>
                              <div>
                                <button title="Download food items in excel" className="btn btn-success btn-sm text-uppercase sm-text mr-2 rounded" onClick={()=>handleFoodCsv()} >Export Csv <i className="fa fa-download"></i></button>
                                <button title="Upload food items in excel" className="btn btn-primary btn-sm text-uppercase sm-text rounded" onClick={()=>setUploadCsvModal(true)}>Import Csv <i className="fa fa-upload"></i></button>
                              </div>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-1 align-items-center">
                              {/*item desc default image */}
                              <div className="col-md-4 d-flex justify-content-center">
                                <button title="Remove item description" className="btn btn-success btn-sm text-uppercase sm-text mr-2 rounded" onClick={()=>handleItemConfirmation("You want to remove item description?","desc")} >Remove Desc</button>
                                <button title="Add default item image" className="btn btn-primary btn-sm text-uppercase sm-text rounded" onClick={()=>handleItemConfirmation("You want to add default item image?","image")}>Default Img</button>
                              </div>
                              {/* Search group */}
                              <div className="col-md-5 t-mb-15 mb-md-0">
                                <div className="input-group">
                                  <div className="form-file">
                                    <input
                                      id="item_search"
                                      type="text"
                                      className="form-control border-0 form-control--light-1 rounded-left"
                                      placeholder={
                                        _t(t("Search by name")) + ".."
                                      }
                                      onChange={handleSearch}
                                    />
                                  </div>
                                  <button
                                    className="btn btn-primary rounded-right"
                                    type="button"
                                  >
                                    <i
                                      className="fa fa-search "
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              {/* Add group modal trigger button */}
                              <div className="col-md-3 text-md-right">
                                <NavLink
                                  to="/dashboard/manage/food/add-new"
                                  className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                >
                                  {_t(t("add new"))}
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Table */}
                        <div className="">
                          <table className="table table-bordered table-hover min-table-height">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("S/L"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                  style={{minWidth: '100px'}}
                                >
                                  {_t(t("Item Code"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                  style={{minWidth: '100px'}}
                                >
                                  {_t(t("Image"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Name"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Menu"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Group"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Sub Category"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Food Department"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Price"))}
                                </th>
                                
                                {/* <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Status"))}
                                </th>*/}

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Action"))}
                                </th>
                                <th
                                  scope="col"
                                  className="table_report_col sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Sku"))}
                                </th>
                                <th
                                  scope="col"
                                  className="table_report_col sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Created"))}
                                </th>
                                <th
                                  scope="col"
                                  className="table_report_col sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Updated"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                              {!searchedFoodItem.searched
                                ? [
                                    foodList && foodList?.data && [
                                      foodList?.data?.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="6"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        foodList?.data.map((item, index) => {
                                          return foodDataList(item,index)
                                        })
                                      ),
                                    ],
                                  ]
                                : [
                                    /* searched data, logic === haveData*/
                                    searchedFoodItem && [
                                      searchedFoodItem.list.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="6"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        searchedFoodItem.list.map(
                                          (item, index) => {
                                            return foodDataList(item,index)
                                          }
                                        )
                                      ),
                                    ],
                                  ]}
                            </tbody>
                          </table>
                        </div>
                      </div>                    
                  </div>
                </div>
              </div>

              {/* pagination loading effect */}
              {variations.uploading === true || loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searchedFoodItem.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination(foodList, setPaginatedFood)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData(foodList)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    setSearchedFoodItem({
                                      ...searchedFoodItem,
                                      searched: false,
                                    })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                    searchedFoodItem,
                                    foodForSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
        <div
          className={`modal fade ${
            foodSort ? "showing" : ""
          }`}
          id="foodItem"
          aria-hidden="true"
        >
        <div className="modal-dialog modal-md mt-0 foodSortModal">
          <div className="modal-content">
            <div className="modal-header align-items-center py-1">
              <div className="fk-sm-card__content">
               <h5>{groupName?.current && groupName.current}</h5>
              </div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={()=>setFoodSort(false)}
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
             <form onSubmit={handleUpdateFoodSort} autoComplete="off">
              <div key="fragment-food-group-1">
              {/* show form or show saving loading */}
              <div className="foodSort" >
              <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="listItem" trpe="group">
                {(provided,snapshot) => (
                  <div {...provided.droppableProps} ref={provided.innerRef} >
                    {listItem.map((item, index) => {
                      return (
                        <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                          {(provided,snapshot) => (
                            <div  style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                           )} className="food_sort_name" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                              <div >
                                {item.name}
                              </div>
                            </div>
                            )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                )}
                </Droppable>
              </DragDropContext>
              </div>
              <div className="m-1 d-flex justify-content-end mr-2 px-1">
              <button disabled={loading} type="submit" className="btn btn-sm rounded btn-primary">Submit</button>
              </div>
                 {/*
                   listItem && listItem.map((item,index)=>{
                     return(
                       item.current_id !== item.item_id &&(
                      <div
                       key={index}
                       className="cursor-pointer border-1 border rounded mb-1"
                       >
                        <input
                          type="radio"
                          className="form-check-input pointer-cursor"
                          onChange={(e) => {
                            handleGroupSort(e,item);
                          }}
                          checked={
                            sortedList && sortedList?.id === item.id ? 1 : 0
                          }
                        />
                        {item.name}
                      </div>
                      )
                     )
                   })
                  */}
              </div>
             </form>
            </div>
          </div>
        </div>
      </div>    
      </main>
      <FoodDeal
        createDeal = {createDeal}
        setCreateDeal = {setCreateDeal}
        setSearchedFoodItem = {setSearchedFoodItem}
        searchedFoodItem = {searchedFoodItem}
        loading={loading}
        setLoading = {setLoading}
      />
      {/* main body ends */}
    </>
  );
};

export default FoodItemDeptList;
